import { SortDirectionCapital } from '../../../../types'
import { getInitialPaginationDataFromKeys } from '../../../../utils'
import {
  defaultUsersRegistrationPlatforms,
  defaultUsersRoles,
  defaultUsersSignInTypes,
  defaultTraderProfitabilityTags,
  UserAccountScopeEnum,
  UserColumnsEnum,
  UsersData,
  UserColumnKeys,
  UserFiltersEnum,
  UsersPagination,
} from '../api/types'

export const allUserColumns = Object.values(UserColumnsEnum)
export const initialFilters: UserFiltersEnum[] = []
const emptyPeriod: [null, null] = [null, null]

const initialState = {
  list: [] as UsersData['data'],
  pagination: {
    ...(getInitialPaginationDataFromKeys<UserColumnKeys, UserFiltersEnum[]>(
      allUserColumns,
      initialFilters,
    ) as UsersData['meta']),
    orderBy: 'createdAt' as UserColumnKeys,
    order: SortDirectionCapital.desc,
    accountScope: UserAccountScopeEnum.all,
    roles: defaultUsersRoles,
    registrationPlatforms: defaultUsersRegistrationPlatforms,
    signInTypes: defaultUsersSignInTypes,
    emailVerified: undefined,
    questionnaireCompleted: undefined,
    profitabilityTags: defaultTraderProfitabilityTags,
    createdAtPeriod: emptyPeriod,
    lastLoginAtPeriod: emptyPeriod,
    lastActiveAtPeriod: emptyPeriod,
  } as UsersPagination,
  loading: 'idle',
}

export type StateType = typeof initialState

export default initialState
